export const GET_BIOCHAR_METADATA = 'GET_BIOCHAR_METADATA'
export const GET_BIOCHAR_METADATA_SUCCESS = 'GET_BIOCHAR_METADATA_SUCCESS'
export const GET_BIOCHAR_METADATA_FAIL = 'GET_BIOCHAR_METADATA_FAIL'
export const RESET_BIOCHAR_METADATA = 'RESET_BIOCHAR_METADATA'

export const GET_BIOCHAR_FORM_DATA_SUCCESS = 'GET_BIOCHAR_FORM_DATA_SUCCESS'
export const GET_BIOCHAR_FORM_DATA_FAIL = 'GET_BIOCHAR_FORM_DATA_FAIL'

export const SET_BIOCHAR_FORM_DATA = 'SET_BIOCHAR_FORM_DATA'
export const RESET_BIOCHAR_ALL_DATA = 'RESET_BIOCHAR_ALL_DATA'

export const RESPONSE_STATE_SUCCESS = 'RESPONSE_STATE_SUCCESS'
export const RESPONSE_STATE_FAIL = 'RESPONSE_STATE_FAIL'

export const GET_FEEDSTOCK_TYPE_OPTIONS_SUCCESS = 'GET_FEEDSTOCK_TYPE_OPTIONS_SUCCESS'
export const GET_FEEDSTOCK_TYPE_OPTIONS_FAIL = 'GET_FEEDSTOCK_TYPE_OPTIONS_FAIL'

export const GET_TEMPERATURE_TYPE_OPTIONS_SUCCESS = 'GET_TEMPERATURE_TYPE_OPTIONS_SUCCESS'
export const GET_TEMPERATURE_TYPE_OPTIONS_FAIL = 'GET_TEMPERATURE_TYPE_OPTIONS_FAIL'